import React from "react";

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="400"
    height="400"
    viewBox="0 0 400 400"
  >
    <g>
      <path
        d="M186.121 9.413 C 41.371 19.192,-39.914 184.579,40.626 305.446 C 121.505 426.819,304.298 416.827,369.918 287.446 C 437.554 154.086,335.256 -0.663,186.121 9.413 M213.333 95.436 C 248.075 104.179,263.850 145.217,244.172 175.657 C 223.814 207.147,176.186 207.147,155.828 175.657 C 129.588 135.067,166.454 83.639,213.333 95.436 M223.108 225.273 C 254.419 230.576,281.473 241.975,295.065 255.593 C 303.980 264.525,306.177 270.783,305.858 286.333 L 305.667 295.667 200.000 295.667 L 94.333 295.667 94.142 286.333 C 93.823 270.783,96.020 264.525,104.935 255.593 C 120.120 240.379,153.575 227.507,187.667 223.761 C 194.220 223.041,215.218 223.937,223.108 225.273 "
        stroke="none"
        fill="currentColor"
        fillRule="evenodd"
      ></path>
    </g>
  </svg>
);
